import React from "react"

import SelectTags from "../../../common/tags/SelectTags"

const CommunityEditRelatedItems = ({
    topics,
    dimensions,
    communities,
    projects,
    onCommunitiesSearch,
    onTopicsSearch,
    onDimensionsSearch,
    onProjectsSearch,
    onEventChange,
    onValueChange
}) => (
    <div className="widget">
        <div className="widget-content visible">
            <h3 className="first-heading">
                <span className="icon icon-insights" />Insight areas
            </h3>
            <SelectTags
                value={topics}
                loadOptions={onTopicsSearch}
                placeholder="Insight areas"
                onChange={onValueChange("topics")}
            />
            <h3>
                <span className="icon icon-insights" />Key issues
            </h3>
            <SelectTags
                value={dimensions}
                loadOptions={onDimensionsSearch}
                placeholder="Key issues"
                onChange={onValueChange("dimensions")}
            />
            <h3>
                <span className="icon icon-community" />Communities
            </h3>
            <SelectTags
                value={communities}
                loadOptions={onCommunitiesSearch}
                placeholder="Communities"
                onChange={onValueChange("communities")}
            />
            <h3>
                <span className="icon icon-concepts" />Projects
            </h3>
            <div style={{ paddingBottom: "30px" }}>
                <SelectTags
                    value={projects}
                    loadOptions={onProjectsSearch}
                    placeholder="Projects"
                    onChange={onValueChange("projects")}
                />
            </div>
        </div>
    </div>
)

export default CommunityEditRelatedItems
